import { render } from "./ComposeBox.vue?vue&type=template&id=b7779782&scoped=true"
import script from "./ComposeBox.vue?vue&type=script&lang=js"
export * from "./ComposeBox.vue?vue&type=script&lang=js"

import "./ComposeBox.vue?vue&type=style&index=0&id=b7779782&lang=sass&scoped=true"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7779782"]])

export default __exports__